import {useEffect,useState} from 'react'
import {api} from '../../lib/api.js'
import {useSessionGeneration} from '../../lib/useSessionGeneration.js'
import {useToolAccess} from '../../lib/toolAccess.jsx'
import {familyById,normalizeSequenceContext,validSequenceProof} from '../../lib/outreachFamily.js'

export function useOutreachSequenceContext({championshipId,angle,proof=null,recipient=null,sender,enabled,refreshKey=0}){
 const session=useSessionGeneration(),access=useToolAccess(),[read,setRead]=useState({scope:null,state:'idle'}),[refresh,setRefresh]=useState(0)
 const ready=Boolean(enabled&&access?.data)
 const scope=JSON.stringify([session,access?.data?.version,access?.data?.fingerprint,access?.data?.active,championshipId,angle,proof,recipient,sender,ready,refreshKey,refresh])
 useEffect(()=>{
  let active=true;const controller=new AbortController()
  if(!ready||!championshipId||!familyById(angle)||!sender?.id||!sender?.name){setRead({scope,state:'idle'});return()=>controller.abort()}
  if(proof&&!validSequenceProof(proof)){setRead({scope,state:'error',error:'The selected artwork identity is unavailable.'});return()=>controller.abort()}
  setRead({scope,state:'loading'})
  const expected={championshipId,angle,proof,recipient,sender},query={angle,...(proof||{}),...(recipient?{recipientContactId:recipient.contactId,recipientEmail:recipient.email}:{})}
  api.outreachSequenceContext(championshipId,query,{signal:controller.signal}).then(response=>{
   const context=normalizeSequenceContext(response,expected);if(active)setRead({scope,state:'ready',context})
  }).catch(error=>{if(active&&error.name!=='AbortError')setRead({scope,state:'error',error:'Current campaign evidence is unavailable. No fallback copy or draft was selected.'})})
  return()=>{active=false;controller.abort()}
  // The complete request identity is serialized above, including session and
  // current sender. A late result cannot populate another account or purpose.
  // eslint-disable-next-line react-hooks/exhaustive-deps
 },[scope])
 return {...(read.scope===scope?read:{state:'loading'}),refresh:()=>setRefresh(value=>value+1)}
}
